import { render, staticRenderFns } from "./chooseBase.vue?vue&type=template&id=5874d189&scoped=true"
import script from "./chooseBase.vue?vue&type=script&lang=js"
export * from "./chooseBase.vue?vue&type=script&lang=js"
import style0 from "./chooseBase.vue?vue&type=style&index=0&id=5874d189&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5874d189",
  null
  
)

export default component.exports